<div class="grid grid-rows-[auto,1fr,auto] bg-hero-radial text-white">
  <app-header></app-header>

  <main
    id="main-content"
    tabindex="-1"
    class="grid min-h-[calc(100vh-350px)] place-items-center px-5 py-8 outline-none md:px-8 lg:min-h-[calc(100vh-256px)] lg:py-0"
  >
    <router-outlet></router-outlet>
  </main>

  <app-footer [isPublic]="true"></app-footer>
</div>
